import { Card, CardContent, Link, Typography } from "@mui/material";
import React from "react";
import { MdIntegrationInstructions } from "react-icons/md";
import { Link as RouterLink } from "react-router-dom";

const integrations = [
  {
    name: "Google Sheets",
    path: "google-sheet",
    icon: <MdIntegrationInstructions />,
  },
];

export const Integrations = () => {
  return (
    <div>
      <h3 className="mb-8">Интеграции</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">
        {integrations.map((integration) => (
          <Card key={integration.path}>
            <CardContent>
              <div className="flex justify-center items-center w-full h-full mb-4">
                <div className="flex justify-center items-center mr-2 text-2xl">
                  {integration.icon}
                </div>
                <Link component={RouterLink} to={`/admin/integrations/${integration.path}`}>
                  <Typography variant="body1">{integration.name}</Typography>
                </Link>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
